function fileToResizedBase64(file, maxSize) {
  if (maxSize === void 0) {
    maxSize = 640;
  }
  // console.log('fileToResizedBase64', file, maxSize);
  return new Promise((resolve, reject) => {
    if (!file.type.match(/image.*/)) {
      reject('not a valid image file');
    }
    // Load the image
    const reader = new FileReader();
    reader.onload = function (readerEvent) {
      var _a;
      if ((_a = readerEvent === null || readerEvent === void 0 ? void 0 : readerEvent.target) === null || _a === void 0 ? void 0 : _a.result) {
        const image = new Image();
        image.onload = function (imageEvent) {
          const canvas = document.createElement('canvas');
          let width = image.width;
          let height = image.height;
          if (width > height) {
            if (width > maxSize) {
              height *= maxSize / width;
              width = maxSize;
            }
          } else {
            if (height > maxSize) {
              width *= maxSize / height;
              height = maxSize;
            }
          }
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d');
          if (context) {
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL('image/jpeg');
            // const resizedImage = dataURLToBlob(dataUrl);
            resolve(dataUrl);
          } else {
            reject('unable to create canvas 2d context');
          }
        };
        image.src = readerEvent.target.result;
      } else {
        reject(`unable to read file ${file.name}`);
      }
    };
    reader.readAsDataURL(file);
  });
}
function formatBytes(bytes, decimals) {
  if (decimals === void 0) {
    decimals = 2;
  }
  if (!+bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export { fileToResizedBase64, formatBytes };
//# sourceMappingURL=upload.js.map
